import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/services/analyticsService';
import { useAuth } from '@/hooks/auth';
import { logger } from '@/utils/logger';

export const usePageTracking = () => {
  const location = useLocation();
  const previousPath = useRef<string>();
  const { user } = useAuth();

  // Remove redundant analytics.setUserId call - handled in AuthProvider now

  useEffect(() => {
    if (previousPath.current !== location.pathname) {
      // Get the document title for better tracking
      const pageTitle = document.title || 'Unknown Page';
      
      if (analytics?.trackPageView) {
        analytics.trackPageView(location.pathname, pageTitle);
        logger.performance('Page tracked:', location.pathname);
      }
      
      previousPath.current = location.pathname;
    }
  }, [location]);
};
